import { Button, Card, CardActions, CardContent, CardHeader, Divider, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { ErrorMessage } from "components";
import LoadingIndicator from "components/LoadingIndicator";
import moment from "moment";
import PropTypes from "prop-types";
import React, { Fragment, useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Slot } from "services";
import useErrorCatcher from "utils/useErrorCatcher";
import snakeToCamel from "utils/snakeToTitle";

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(3),
  },
  content: {
  },
  actions: {
    flexDirection: "column",
    alignItems: "flex-start",
    "& > * + *": {
      marginLeft: 0
    }
  },
  notice: {
    marginTop: theme.spacing(1)
  },
  italics_light: {
    opacity: 0.7,
    fontStyle: "italic",
  },
  spinner: {
    marginTop: theme.spacing(3),
  },
  mono: {
    fontFamily: ["Roboto Mono", "monospace"],
  },
  strong: {
    fontWeight: "600"
  }
}));

let mounted = false;
const SlotPreview = props => {
  const { slotId, slot, title = "Slot", className, ...rest } = props;
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  let [model, setModel] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const runAsyncBlock = useErrorCatcher(error => setErrorMessage(error && error.message));

  useEffect(() => {
    mounted = true;
    return () => mounted = false;
  }, [])

  useEffect(() => {
    if (!slot) {
      runAsyncBlock(async () => {
        const { model } = await Slot.detail(slotId);
        if (mounted) setModel(model);
      }).finally(() => mounted && setLoading(false));

      return () => {
        if (mounted) setModel(null);
      };
    }
    // eslint-disable-next-line
  }, [slotId]);

  if (!slot && !slotId) return null;
  if (slot) model = slot;

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <CardHeader title={`${title}`} />
      <Divider />
      <CardContent className={classes.content}>
        <ErrorMessage message={errorMessage} />
        <LoadingIndicator className={classes.spinner} variant="card" active={loading} />
        {model && (
          <Fragment>
            <Typography variant="h4"></Typography>
            <Typography variant="h3">{moment(model.start_at).format("HH:mm")} - {moment(model.end_at).format("HH:mm")}</Typography>
            <Typography variant="body1"><span className={classes.strong}>{moment(model.start_at).format("DD/MM/YYYY")}</span> | {model.duration / 60} min</Typography>
            <Typography variant="body2" >{snakeToCamel(model.status)}</Typography>
          </Fragment>
        )}
      </CardContent>
      <CardActions className={classes.actions}>
        <Button component={RouterLink} size="small" to={`/lesson_slots/${slotId || slot.id}/summary`}>
          View {title} Details
        </Button>
      </CardActions>
    </Card>
  );
};

SlotPreview.propTypes = {
  className: PropTypes.string,
};

export default SlotPreview;
